import { React, useState, useEffect } from 'react';
import axios from 'axios';
import { ShimmerThumbnail } from "react-shimmer-effects";
import Itemcards from "../../../components/Cards/similar-wheels-items-card";

export default function Similar(prop) {
  const { sku } = prop;
  const mainUrl = process.env.REACT_APP_EXPRESS_APP_URL;
  const [wheelData, setWheelData] = useState([]);
  // const [brandCountData, setBrandCount] = useState([]);
  // console.log("brandCountData", brandCountData);

  const [isLoading, setIsLoading] = useState(true);
  const vehicalDetails = JSON.parse(localStorage.getItem('vehical_details'));
  const dataYear = vehicalDetails ? vehicalDetails.year : "";
  const dataMake = vehicalDetails ? vehicalDetails.make : "";
  const dataModel = vehicalDetails ? vehicalDetails.model : "";
  const dataModelVarient = vehicalDetails ? vehicalDetails.variant : "";
  const [isdata, setIsdata] = useState(true);

  const [boltPattern, setBoltPattern] = useState("");
  const [customBoltPattern, setCustomBoltPattern] = useState("");




  useEffect(() => {
    fetchWheelSimilarDetails();
  }, []);


  const fetchWheelSimilarDetails = async () => {
    setIsLoading(true);

    try {

      let boltPattern = "";
      let hubBore = "";

      // Only call FitmentAtlas if vehicle is selected
      if (dataYear && dataMake && dataModel) {

        const apiKey = "crQqKW9uFVL1bSu1uymaWx2UFTcvgdKE";

        const smartUrl = `https://api.fitmentatlas.com/v1.1/services/Vehicles/smartsizes/?YearId=${dataYear}&MakeId=${dataMake}&ModelId=${dataModel}&ProductType=wheel&SubmodelID=${dataModelVarient || ""}`;

        const smResponse = await axios.get(smartUrl, {
          headers: {
            "FG-ApiKey": apiKey,
          },
        });

        const results = smResponse.data?.result || [];

        if (results.length > 0) {

          const fmk = results[0].fmk;

          const vehicleResponse = await axios.get(
            `https://api.fitmentatlas.com/v1.1/services/Vehicles/${fmk}`,
            {
              headers: {
                "FG-ApiKey": apiKey,
              },
            }
          );

          const vehicleInfo = vehicleResponse.data?.result;

          boltPattern = vehicleInfo?.vehicleChassis?.boltPattern || "";
          hubBore = vehicleInfo?.vehicleChassis?.hubbore || "";

          setBoltPattern(boltPattern);
        }
      }

      const response = await axios.get(
        `${mainUrl}/api/wheels/getSimilarWheelDetails/${sku}`,
        {
          params: {
            year: dataYear,
            make: dataMake,
            model: dataModel,
            varient: dataModelVarient,
            boltPattern,
            hubBore,
          },
        }
      );

      setWheelData(response.data);
      // setBrandCount(response.data.brandCounts);
      setCustomBoltPattern(response.data.customBoltPattern);


      if (response.data.status === 500) {
        setIsdata(false);
      }

    } catch (error) {
      console.error(error);
      setIsdata(false);
    } finally {
      setIsLoading(false);
    }
  };







  return (
    <>
      <section className='similar-products-acc'>
        <div className="container">

          <div className="col-lg-12 also-bought">
            <div className="row">
              {isdata ? (
                <>
                  {/* {
                    !isLoading && wheelData && wheelData.data && wheelData.data.length > 0 ?

                      <h3 className="Simila-txt py-3">Similar Products Based on Lug Pattern: {wheelData?.data[0]?.bolt_pattern_metric}</h3> : ""
                  } */}

                  {
                    !isLoading &&
                    wheelData?.data?.length > 0 && (
                      <h3 className="Simila-txt py-3">
                        Similar Products for Lug Pattern:{" "}
                        {boltPattern || customBoltPattern?.split("/")[0]}
                      </h3>
                    )
                  }

                  {
                    !isLoading && wheelData ?
                      wheelData.data.length ?
                        wheelData.data.map((itm, idx) => {
                          return (<Itemcards data={itm} key={itm.sku} />);
                        })
                        : ""
                      :

                      Array.from({ length: 5 }).map((_, idx) => (
                        <div className="col-lg-2 col-md-3 col-sm-4 col-6 customeChanges" key={idx}>
                          <div className="card-tyr smilar-product">
                            <div className="tyre-imge-upper">
                              <ShimmerThumbnail height={163} rounded />
                            </div>
                            <div className="cart-body">
                              <h6><ShimmerThumbnail height={10} rounded /></h6>
                              <h4><ShimmerThumbnail height={20} rounded /></h4>
                              <div className="price-cart">
                                <div className="price">
                                  <h5 className="m-0"><ShimmerThumbnail height={20} rounded /></h5>
                                  <h4 className="m-0"><ShimmerThumbnail height={20} rounded /><span><ShimmerThumbnail height={20} rounded /></span></h4>
                                </div>
                                <div className="cart-btn">
                                  <a href="/">
                                    <ShimmerThumbnail height={20} rounded />
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))

                  }</>) : ("")}

            </div>
          </div>
        </div>
      </section>
    </>
  )
}
